import React from "react";

/**
 * Card with a static gradient border — used for featured items
 * (founder card, final CTA strip, etc).
 */
export const GradientBorderCard = ({
    children,
    className = "",
    contentClassName = "",
    radius = 22,
    ...rest
}) => {
    return (
        <div
            className={`relative ${className}`}
            style={{
                padding: 1.5,
                borderRadius: radius,
                background:
                    "linear-gradient(135deg, #EC4899 0%, #8B5CF6 50%, #3B82F6 100%)",
            }}
            {...rest}
        >
            <div
                className={`relative h-full w-full ${contentClassName}`}
                style={{
                    borderRadius: radius - 1.5,
                    background:
                        "linear-gradient(180deg, rgba(26, 11, 61, 0.92) 0%, rgba(15, 7, 32, 0.96) 100%)",
                    backdropFilter: "blur(20px) saturate(140%)",
                    WebkitBackdropFilter: "blur(20px) saturate(140%)",
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default GradientBorderCard;
